import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8de65ccc9e69352/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ccc9e69352/node_modules/next/dist/client/link.js");
